import * as actionTypes from "../actions";
import secureStorage from "../../helpers/locStore";

const initialState = secureStorage.getItem("lang")
  ? secureStorage.getItem("lang")
  : "en";

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LANGUAGE:
      secureStorage.setItem("lang", action.payload);
      return (state = action.payload);
    default:
      secureStorage.setItem("lang", state);
      return state;
  }
};

export default languageReducer;
